import { getRandomMessage } from "../../api/wall";
import wall_images from "./wall-imges";

const strings = {
  createCard: "create_card",
  mission_accomplished: "Mission Accomplished",
  way_to_go: "Way to go. Let's see what magic it creates now",
  keep_in_mind:
    "Keep in mind, this post can be edited/deleted up until the next 7 days only!",
  keep_in_mind_challenge:
    "Keep in mind, this post cannot be edited and only deleted once. But now you can see your peers submissions as well!",
  peer_reaction: "Peer Reaction",
  great_value: "Your comment adds great value....keep them coming",
  response_recorded:
    "Your response has already been recorded. You can only remove it within 7 days of posting",
  delete_post: "Delete Post?",
  quit_challenge: "Confirmation Required",
  finish_posting: "Finish Posting?",
  are_you_sure_to_delete:
    "We are sad. This post wont be seen anymore. Are you sure you want to delete it? We suggest you hide it instead of deleting it.",
  vote_message: "Your vote is registered !",
  ready_to_post:
    "Ready to post? Only one attempt/post is permitted. You wont be able to make any changes once posted since this is a Challenge format",
  no_go_back: "There is no going back after posting!",
  peer_competition: "Votes exhausted",
  competition_complete: "Competition Complete",
  vote_cout: "You can vote for {5} more post",
  exhausted_votes: "You have exhausted all your votes",
  pretty_good_choice: "Pretty good choice! We hope this one gets the award ",
  votes_used:
    "You have used up all {5} votes(s) of yours. You can’t vote any more posts in this challenge!",
  are_you_sure_to_quit:
    "Are you sure you want to delete? You won’t be able to post again as fair-play rule",
  opting_view_mode:
    "You are now opting for view only mode and cannot participate in the challenge by posting. Viewing may be comfortable, but participating is where the magic happens. Embrace the challenge. Are you sure you want to proceed?",

  warning: "I am not participating. I just want to view and vote.",
  opted_view_only: "You have opted for view mode.....",
  user_quit_message: "You have chosen view only mode",
  observations: "Your observations",
  add_post_title: "My Wall Post",
  title_placeholder: "What do you want to call it?",
  desc_placeholder: "Write your thoughts...",
  links_placeholder:
    "Insert links: Add your Youtube or any reference web links here.",
  wall_service: "wall-service",
  edit: "Edit",
  appreciate: "Appreciate",
  delete: "Delete",
  yes: "Yes",
  no: "No",
  post: "Post",
  vote: "Vote",
  hide: "Hide",
  un_hide: "Unhide",
  go_ahead: "Go ahead",
  cancel: "Cancel",
  tag_to_portfolio: "Tag to portfolio",
  tagged_to_portfolio: "Tagged to Portfolio",
  suggest_for_portfolio: "Suggest for portfolio",
  portfolio_suggested: "Suggested for portfolio",
  special_appreciation: "Special Appreciation",
  suggest_for_portfolio_title: "Portfolio suggestion sent",
  portfolio_message:
    "We agree, that was worthy to be in your portfolio. You will see this post as tagged to portfolio now in your Portfolio module. You can go there later and finish making this post as a portfolio item",
  suggest_for_portfolio_message:
    "We agree that this post is definitely worthy to be an Portfolio. @@poststudentname will now see this post as a suggestion by you in their Portfolio module. ",
  initiate_share_appreciation:
    "Here’s a way to let @@poststudentname know that this is an awesome piece of work. ",
  confirm_share_appreciation:
    "Awesome! We hope what goes around come comes around too. Keep spreading the joy with these special appreciations.",
  share_appreciation_exhausted:
    "Unfortunately you have run out of special appreciations gestures. Remember these are limited and hence use them wisely. But, hey we truly appreciate your intent. ",
  remaining_appreciation:
    "You can give a special appreciation for {5} more student",
  appreciation_exhausted: "Appreciation  Limit Exhausted",
  do_something_epic: "Do something epic!",
  respond: "Respond",
  complete: "Complete",
  no_upload_title: "Feeling lonely!",
  no_upload_message: "Waiting for you to kickstart the amazing journey on wall",
  home_page_title: "My Wall-Share",
  home_page_challenge_title: "My Wall-Challenges",
  share_homepage_default_message:
    '"Discover the Learning Wall: Share, Connect, Thrive! Post your learning activities, spark discussions, and engage with a global community of fellow learners. Foster connections through comments, appreciations and discussions – your gateway to a world of educational exploration." So go ahead stick it on the “Wall”',
};
export const WALL_MESSAGE_BANK = "Wall-StudentEngagementActivity";

export const POST_MESSAGE_CATEGORY = "Post related";
export const VOTE_MESSAGE_CATEGORY = "Vote related";
export const APPRECIATION_CATEGORY = "Special Appreciation related";
export const PORTFOLIO_CATEGORY = "Portfolio related";
export const SHARE_HOMEPAGE_CATEGORY = "Wall Share Homepage";
export const CHALLEGE_HOMEPAGE_CATEGORY = "Wall Challenge Homepage";

export const ADD_POST = "Add post";
export const EDIT_POST = "Edit and post again";
export const VIEW_ONLY = "View only";
export const DELETE_POST = "Delete post";
export const ADD_POST_CONFIRMATION = "Add post confirmation";
export const VOTE_EXHAUSTED = "Vote exhausted";
export const MAKE_A_VOTE = "Make a vote";
export const INITIATE_APPRECIATION = "Special Appreciation Initiate";
export const CONFIRM_APPRECIATION = "Special Appreciation Confirm";
export const APPRECIATION_EXHAUSTED = "Special Appreciation exhausted";
export const TAG_TO_PORTFOLIO = "Tag to portfolio";
export const SUGGEST_FOR_PORTFOLIO = "Suggest for portfolio";
export const SHARE_HOMEPAGE = "Wall Share introduction";
export const CHALLEGE_HOMEPAGE = "Wall Challenge Introduction";

export const SHARE_MESSAGE_CATEGORY = "WallShareActivity";
export const CHALLENGE_MESSAGE_CATEGORY = "WallChallengeActivity";

const userDetails = {};

export const getPopupTitle = (type) => {
  let title = "";
  if (type == ADD_POST || type == EDIT_POST) {
    title = strings.mission_accomplished;
  } else if (type == ADD_POST_CONFIRMATION) {
    title = strings.finish_posting;
  } else if (type == DELETE_POST) {
    title = strings.delete_post;
  } else if (type == VIEW_ONLY) {
    title = strings.quit_challenge;
  } else if (type == MAKE_A_VOTE) {
    title = strings.vote_message;
  } else if (type == VOTE_EXHAUSTED) {
    title = strings.peer_competition;
  } else if (type == INITIATE_APPRECIATION || type == CONFIRM_APPRECIATION) {
    title = strings.special_appreciation;
  } else if (type == APPRECIATION_EXHAUSTED) {
    title = strings.appreciation_exhausted;
  } else if (type == TAG_TO_PORTFOLIO) {
    title = strings.tagged_to_portfolio;
  } else if (type == SUGGEST_FOR_PORTFOLIO) {
    title = strings.suggest_for_portfolio_title;
  } else if (type === "upload") {
    title = "Uploading...";
  }

  return title;
};
export const getPopupImage = (type) => {
  let image = "";
  if (
    type == ADD_POST ||
    type == EDIT_POST ||
    type == TAG_TO_PORTFOLIO ||
    type == SUGGEST_FOR_PORTFOLIO
  ) {
    image = wall_images.postSuccess;
  } else if (type == DELETE_POST) {
    image = wall_images.experientialDelete;
  } else if (type == VIEW_ONLY) {
  } else if (type == MAKE_A_VOTE) {
    image = wall_images.voteGif;
  } else if (type == VOTE_EXHAUSTED) {
    image = wall_images.voteExaustedGif;
  } else if (type == INITIATE_APPRECIATION) {
  } else if (type == CONFIRM_APPRECIATION) {
  } else if (type == APPRECIATION_EXHAUSTED) {
  } else if (type === "upload") {
    image = wall_images.experientialLoading;
  }
  return image;
};
export const getPopupMessage = async (
  type,
  isShareActivity,
  messageBank,
  count,
  postUserName
) => {
  let message = "";
  let defaultMessage = "";
  let code = "0";

  if (type == ADD_POST) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      POST_MESSAGE_CATEGORY,
      ADD_POST
    );
    defaultMessage = strings.keep_in_mind;
  } else if (type == EDIT_POST) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      POST_MESSAGE_CATEGORY,
      EDIT_POST
    );
    defaultMessage = strings.keep_in_mind;
  } else if (type == ADD_POST_CONFIRMATION) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      POST_MESSAGE_CATEGORY,
      ADD_POST_CONFIRMATION
    );
    defaultMessage = strings.ready_to_post;
  } else if (type == DELETE_POST) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      POST_MESSAGE_CATEGORY,
      DELETE_POST
    );
    defaultMessage =
      strings[isShareActivity ? "are_you_sure_to_delete" : "delete_post"];
  } else if (type == VIEW_ONLY) {
    code = getMessageBankCode(
      messageBank,
      CHALLENGE_MESSAGE_CATEGORY,
      POST_MESSAGE_CATEGORY,
      VIEW_ONLY
    );
    defaultMessage = strings.opting_view_mode;
  } else if (type == MAKE_A_VOTE) {
    code = getMessageBankCode(
      messageBank,
      CHALLENGE_MESSAGE_CATEGORY,
      VOTE_MESSAGE_CATEGORY,
      MAKE_A_VOTE
    );
    defaultMessage = strings.pretty_good_choice;
  } else if (type == VOTE_EXHAUSTED) {
    code = getMessageBankCode(
      messageBank,
      CHALLENGE_MESSAGE_CATEGORY,
      VOTE_MESSAGE_CATEGORY,
      VOTE_EXHAUSTED
    );
    defaultMessage = strings.votes_used?.replace("{5}", count);
  } else if (type == INITIATE_APPRECIATION) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      APPRECIATION_CATEGORY,
      INITIATE_APPRECIATION
    );
    defaultMessage = strings.initiate_share_appreciation;
  } else if (type == CONFIRM_APPRECIATION) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      APPRECIATION_CATEGORY,
      CONFIRM_APPRECIATION
    );
    defaultMessage = strings.confirm_share_appreciation;
  } else if (type == APPRECIATION_EXHAUSTED) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      APPRECIATION_CATEGORY,
      APPRECIATION_EXHAUSTED
    );
    defaultMessage = strings.remaining_appreciation?.replace("{5}", count);
  } else if (type == TAG_TO_PORTFOLIO) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      PORTFOLIO_CATEGORY,
      TAG_TO_PORTFOLIO
    );
    defaultMessage = strings.portfolio_message;
  } else if (type == SUGGEST_FOR_PORTFOLIO) {
    code = getMessageBankCode(
      messageBank,
      isShareActivity ? SHARE_MESSAGE_CATEGORY : CHALLENGE_MESSAGE_CATEGORY,
      PORTFOLIO_CATEGORY,
      SUGGEST_FOR_PORTFOLIO
    );
    defaultMessage = strings.suggest_for_portfolio_message;
  } else if (type == SHARE_HOMEPAGE) {
    code = getMessageBankCode(
      messageBank,
      SHARE_MESSAGE_CATEGORY,
      SHARE_HOMEPAGE_CATEGORY,
      SHARE_HOMEPAGE
    );
    defaultMessage = strings.share_homepage_default_message;
  } else if (type == CHALLEGE_HOMEPAGE) {
    code = getMessageBankCode(
      messageBank,
      CHALLENGE_MESSAGE_CATEGORY,
      CHALLEGE_HOMEPAGE_CATEGORY,
      CHALLEGE_HOMEPAGE
    );
    defaultMessage = strings.share_homepage_default_message;
  }

  let response = await getMessage(code, postUserName);
  message = response?.replace("{5}", count) || defaultMessage;
  return message;
};
export const getMessageBankCode = (
  messageBank,
  category,
  messageCategory,
  messageType
) => {
  let res = messageBank?.find(
    (item) =>
      item?.categoryType == category &&
      item?.messageCategory == messageCategory &&
      item?.messageType == messageType
  );
  return res?.messageCode || 0;
};
export const getMessage = async (code, userName) => {
  userName = userName || "";
  const { success, data } = await getRandomMessage(code);
  if (success && data?.status) {
    let res = data?.message?.replace("@@myname", userDetails?.firstName);
    res = res?.replace("@@poststudentname", userName);
    return res;
  } else {
    return;
  }
};
